import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisTabButton from "../../components/controls/jisTabButton";
import NewGif from "../../assets/new_icon.gif";
import JisDialogForm from "../../components/formdialog";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import JisPrepareTemplate from "../../components/core/preparetemplate";
import JisAlert from "../../components/jisalert";

function CourtRegisterCases() {
  const navigate = useNavigate();
  const { eventtype } = useParams();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isCmc, setIsCmc] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [roles, setRoles] = useState([]);
  const [judges, setJudges] = useState([]);
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [roleCase, setRoleCase] = useState("all");
  const [caseStatus, setCaseStatus] = useState("pending");
  const [schedule, setSchedule] = useState({});
  const [judge, setJudge] = useState(null);
  const [processCase, setProcessCase] = useState("all");
  const [openClear, setOpenClear] = useState(false);
  const [clearCommnent, setClearComment] = useState("");
  const [caseStatusId, setCaseStatusId] = useState(137); //previously 136
  const [predate, setPredate] = useState("");
  const [pretime, setPretime] = useState("");
  const [roleName, setRoleName] = useState("Service Sheriff");

  //service sheriff part
  const [selectedParty, setSelectedParty] = useState(null);
  const [selectedService, setSelectedService] = useState("substituted"); //true/false
  const [caseParties, setCaseParties] = useState([]);
  const [template, setTemplate] = useState(null);
  const [service, setService] = useState(null);
  const [doc, setDoc] = useState(null);
  const [docline, setDocline] = useState(null);
  const [uplinetype, setUplinetype] = useState("attest");
  const [servedon, setServedOn] = useState(null);
  const [sFile, setSFile] = useState(null);
  const [claimants, setClaimants] = useState("");
  const [defendants, setDefendants] = useState("");
  const [isAddService, setIsAddService] = useState(false);
  const [services, setServices] = useState([]);
  const [autoFill, setAutoFill] = useState([]);
  const [otherAlert, setOtherAlert] = useState({ open: false });
  const [sheriffs, setSheriffs] = useState([]);
  const [selectedSheriff, setSelectedSheriff] = useState(null);
  useEffect(() => {
    //onSearch(search);
    onGetJudge();
  }, []);

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
    if (sheriffs.length == 0) {
      onLoadSheriffByDivision();
      onLoadTemplate();
    }
  }, [pageIndex, pageSize, search, caseStatus]);

  const onCaseStateChange = (s) => {
    setCases([]);
    setCaseStatus(s);
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/register-notice/${caseStatus}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onGetJudge = async () => {
    //for account registration

    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getjudgedetails-profile`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      var judge = data.judge;
      if (judge != null) {
        setJudge({
          ...judge,
          courtName: data.courtname,
          judgeType: data.judgetype,
          lastRank: data.lastRank,
        });
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    //navigate(`/case-details/${caseid}`)
    setActive(fee);
    setIndex(ind);
    setOpenCase(true);
  };

  const onPreview = (fee, ind) => {
    //navigate(`/case-details/${caseid}`)
    setActive(fee);
    setIndex(ind);
    setIsPreview(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };
  const onCloseClear = () => {
    setActive(null);
    setIndex(-1);
    setOpenClear(false);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };

  //********************************* */ service sherrif part

  useEffect(() => {
    if (isAddService && active != null) {
      //load the parties to the case
      onLoadParties(active.case?.caseId);
    }
  }, [active, isAddService]);

  useEffect(() => {
    if (selectedSheriff != null) {
      //load the parties to the case
      onAssignSheriff();
    }
  }, [selectedSheriff]);

  useEffect(() => {
    if (active != null && selectedParty != null) {
      console.log("in here befor template call");
      let fill = [
        {
          holder: "[DEFENDANT]",
          value: `${selectedParty.firstName} ${selectedParty.lastName ?? ""}`,
        },
        { holder: "[CLAIMANTS]", value: claimants },
        { holder: "[DEFENDANTS]", value: defendants },
      ];

      setAutoFill(fill);
      onLoadService(active.caseId, selectedParty?.id);
      setSFile(null);
      setIsPreview(false);
    }
  }, [selectedParty]);
  useEffect(() => {
    if (active != null && selectedParty != null) {
      if (uplinetype == "template") {
        onLoadTemplate();
      }
    }
  }, [selectedService]);
  const onLoadSheriffByDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/get-Service-Sheriff`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSheriffs(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onAddService = (kase, ind) => {
    const division = Constants.getItemById(
      frequentData?.divisions,
      kase?.case?.divisionId,
    )?.title;
    var _kase = {
      ...kase,
      division,
      caseType: kase?.case?.caseFilingId == 1 ? "litigation" : "adr",
      type: "document",
    };
    setActive(_kase);
    console.log(`on continue ${division}`);
    console.log(_kase);
    setIndex(ind);
    setIsAddService(true);
  };

  const onOkUpload = () => {
    setOtherAlert({ open: false });
    onPrepareDone({ source: "upload" });
  };
  const onInstumentAppended = (e) => {
    //after saving of instrument, this is what you get
    if (e.code == 0) {
      //saved already
    }
  };
  const handleUploadChange = async (e) => {
    const files = e.target.files;
    console.log(files[0]);
    var b64 = await Constants.toBase64(files[0]);
    var path = URL.createObjectURL(files[0]);
    var fname = Constants.ReduceFilename(files[0]?.name);

    var a = {
      path,
      base64: b64.split(",")[1],
      filename: fname,
      base64Ext: b64.split(",")[0],
    };

    setSFile(a);

    console.log(a);
  };
  const onUploadFiles2 = async (caseid, partyid) => {
    const uploadurl = `${Constants.apiUrl}/filing/upload-service-sheriff-document/${caseid}/${partyid}`;
    var upline = {
      id: service.docUploadLineId,
      uplineType: "non-attest",
      base64: sFile.base64,
      base64Ext: sFile.base64Ext,
      templateId: 0,
      templatetitle: "",
      filename: sFile.filename,
      docuploadid: service.docUploadId,
    };

    //  setFlowError('');

    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(upline),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          /* setOpenDialog(true);
                      setUploadCode(data.psastatus);
                      setisAttendedTo(data.isAttendedTo) */
          setService({ ...service, isAttendedTo: true });
          setOtherAlert({
            open: true,
            title: "Upload Document",
            subtitle: "Proof of service uploaded",
            onOk: onOkUpload,
          });
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };
  const onSaveFile = () => {
    onUploadFiles2(active.caseId, selectedParty.id);
  };
  const onSelectParty = (p) => {
    /*  const isD = IsDefendant(p.partyTypeId);
      if (!isD) {
        return;
      } */
    setSelectedParty(p);
  };

  const onPrepareDone = (e) => {
    //this is coming from from Prepare Document
    console.log("in service sherrif");

    onUpdateStatus();

    console.log(
      `defendant count ${defendants} while services count ${services.length}`,
    );
  };
  const onUpdateStatus = async () => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/service-sheriff-notice-update/${active?.id}/${active?.caseId}`,
        {
          method: "POST",
          // body:JSON.stringify(approve) ,
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        setIsAddService(false);
        setPageIndex(-1);
        setDoc(null);
        setDocline(null);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);

      // onMove();
    }
  };
  const onAssignSheriff = async () => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/assign-sheriff-to-sheriff/${active?.id}/${active?.caseId}/${selectedSheriff}`,
        {
          method: "POST",
          // body:JSON.stringify(approve) ,
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);

      // onMove();
    }
  };

  const onCloseService = () => {
    setActive(null);
    setIndex(-1);
    setIsAddService(false);
    setSelectedParty(null);
    setService(null);
    setDoc(null);
  };

  const IsDefendant = (ptid) => {
    const v = Constants.getItemById(frequentData.partyTypes, ptid).isLead;
    var m = v ?? false;
    return !m;
  };
  const onLoadParties = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/loadparties/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setCaseParties(data.parties);
        let claim = "";
        let defe = "";
        data.parties.forEach((element) => {
          if (IsDefendant(element.partyTypeId)) {
            defe = defe + `${element.firstName} ${element.lastName ?? ""},`;
            console.log(`in defendant loop ${defe}`);
          } else {
            claim = claim + `${element.firstName} ${element.lastName ?? ""},`;
            console.log(`in claimant loop ${claim}`);
          }
        });
        setDefendants(defe);
        setClaimants(claim);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadServices = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/load-services-hearing-notice/${active.id}/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setServices(data.service);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadTemplate = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/load-special-template/hearing-notice`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setTemplate(data.temp);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadService = async (caseid, partyid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/loadparty-hearing-notice/${active.id}/${caseid}/${partyid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //setCaseParties(data.parties);
        setService(data.service);
        setDoc(data.docup);
        setDocline(data.line);
        if (data.service != null) {
          setSelectedService("hearing-notice");
        }
        const istemp = data.service.isTemplate ?? false;
        console.log("changed at this point ***********1");
        // setUplinetype(istemp?'template':'document');
        if (data.service.servedOn != null) {
          setServedOn(data.service.servedOn.split("T")[0]);
          console.log(data.service.servedOn);
          console.log(data.service.servedOn);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div>
      <CaseSearch
        onSearch={onDirectSearch}
        frequentData={frequentData}
        filingtype="all"
      />

      <div className="tab_body">
        <div className="tab_section">
          <JisTabButton
            code="pending"
            isActive={caseStatus == "pending"}
            title="Pending"
            isRoleBased={false}
            onClick={() => onCaseStateChange("pending")}
          />
          <JisTabButton
            code="assigned"
            isActive={caseStatus == "assigned"}
            title="Assigned"
            isRoleBased={false}
            onClick={() => onCaseStateChange("assigned")}
          />
          <JisTabButton
            code="served"
            isActive={caseStatus == "served"}
            title="Served"
            isRoleBased={false}
            onClick={() => onCaseStateChange("served")}
          />
          {/*  <JisTabButton code="scheduled" isActive={caseStatus=='served'}  title="Accepted Cases" data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('scheduled')}/>    
             <JisTabButton code="concluded" isActive={caseState=='concluded'}  title="Concluded " data={null} isRoleBased={false}  onClick={()=> onCaseStateChange('concluded')}/>    */}
        </div>
        {caseStatus == "pending" && (
          <div className="tab_view">
            {cases?.length == 0 && <JisEmptyList />}
            {cases?.length > 0 && (
              <div className="table">
                <div class="section-cases">
                  <span>Unschedule Cases</span>
                </div>
                <table class="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Filing Type</th>
                      <th className="col-medium">Classification</th>
                      <th className="col-medium">Case Age(Days)</th>
                      <th className="col-medium">Date Initiated</th>
                      <th className="col-medium">Status Level</th>
                      <th className="col-medium">Schedule Date</th>
                      <th className="col-title">Details</th>
                      <th className="col-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((opt, index) => {
                      const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              backgroundColor: `${
                                Constants.getItemById(
                                  frequentData?.casecategories,
                                  opt.case?.caseCategoryId,
                                )?.colour
                              }`,
                            }}
                          >
                            {opt.case?.caseNumber || "N/A"}
                          </td>
                          <td>{opt.case?.caseTitle || "N/A"}</td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casetype,
                              opt.case?.caseTypeId,
                            )?.caseType1 || "N/A"}
                          </td>
                          <td>
                            {" "}
                            {Constants.getItemById(
                              frequentData?.casecategories,
                              opt.case?.caseCategoryId,
                            )?.categoryTitle || "N/A"}
                          </td>
                          <td>
                            {moment().diff(opt.createdOn, "days") || "N/A"}
                          </td>
                          <td>
                            {Constants.momentDate(opt.case?.createdOn).format(
                              "DD MMM, YYYY",
                            ) || "N/A"}
                          </td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casestatuses,
                              opt.case?.caseStatusId,
                            )?.description || "N/A"}
                          </td>
                          <td>
                            {Constants.momentDate(opt.scheduleDate).format(
                              "DD MMM, YYYY",
                            ) || "N/A"}
                          </td>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt.case, index)}
                            >
                              View
                            </JisButton>
                          </td>
                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onAddService(opt, index)}
                            >
                              Process Notice
                            </JisButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {cases?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <BackLoader open={loading} />
      {otherAlert.open && <JisAlert {...otherAlert} />}

      {openCase && active != null && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.case?.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {isAddService && (
        <JisDialogForm
          title={`Notice Of Hearing: ${active?.case?.caseNumber}`}
          onClose={onCloseService}
          minWidth="80%"
        >
          <div>
            <div className="tab-content">
              <div>
                <div className="select-group">
                  <label>Service Sheriff</label>
                  <select
                    name="selectedSheriff"
                    value={selectedSheriff}
                    onChange={(e) => setSelectedSheriff(e.target.value)}
                    required
                  >
                    <option value="">Select service sheriff</option>
                    {sheriffs?.map((opt) => (
                      <option key={opt.id} value={opt.id}>
                        {opt.suffix} {opt.firstName} {opt.lastName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ fontWeight: "bold" }}>SERVED ON</div>
                <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                  {caseParties?.map((opt) => (
                    <div
                      key={opt.id}
                      className={`selected ${opt.id == selectedParty?.id ? "active" : ""}`}
                      onClick={() => onSelectParty(opt)}
                      style={{ maxWidth: 300 }}
                    >
                      {opt.suffix} {opt.firstName} {opt.lastName ?? ""}
                      <br />
                      <div>
                        {
                          Constants.getItemById(
                            frequentData.partyTypes,
                            opt.partyTypeId,
                          ).title
                        }
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ flex: 3, paddingLeft: 16 }}>
                  {selectedParty != null && (
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", maxWidth: 450 }}>
                        <span style={{ padding: 8 }}>Type Of Document </span>
                        <div
                          className={`selected ${uplinetype == "template" ? "active" : ""}`}
                          onClick={() => setUplinetype("template")}
                        >
                          Template
                        </div>
                        <div
                          className={`selected ${uplinetype == "attest" ? "active" : ""}`}
                          onClick={() => setUplinetype("attest")}
                        >
                          Upload Document
                        </div>
                      </div>
                    </div>
                  )}

                  {uplinetype != "template" && (
                    <div style={{ display: "flex" }}>
                      <div className="btn-upload">
                        <input
                          type="file"
                          accept="application/pdf"
                          id={`file-upload-${0}`}
                          onChange={(e) => handleUploadChange(e)}
                        />
                        <label
                          htmlFor={`file-upload-${0}`}
                          title={sFile?.filename}
                        >
                          {sFile?.path == null
                            ? "Choose File"
                            : Constants.ReduceString(sFile?.filename, 30)}
                        </label>
                        {sFile?.path != null && (
                          <JisButton onClick={() => onPreview(sFile)}>
                            Preview
                          </JisButton>
                        )}
                      </div>
                      <div>
                        {service != null && (
                          <JisButton onClick={onSaveFile}>Save File</JisButton>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="view-doc">
                    {doc != null &&
                      docline != null &&
                      template != null &&
                      !service?.isCompleted &&
                      uplinetype == "template" && (
                        <JisPrepareTemplate
                          templatedoc={{
                            ...doc,
                            upline: docline,
                            template: template,
                          }}
                          docInfo={active.case}
                          isLegal={true}
                          onDone={onPrepareDone}
                          onInstumentAppended={onInstumentAppended}
                          doctype="hearing-notice"
                          autoFill={autoFill}
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default CourtRegisterCases;
